// Cohort dates are plain "YYYY-MM-DD" strings; parse as local calendar dates so they never shift.
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const parts = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return { y, m: m - 1, d };
};

const todayStr = () => {
  const t = new Date();
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
};

export const cohortMonth = (c) => MONTHS[parts(c.start_date).m];
export const cohortYear = (c) => parts(c.start_date).y;

export const cohortDayRange = (c) => {
  const s = parts(c.start_date);
  const e = parts(c.end_date);
  return s.m === e.m ? `${s.d}–${e.d}` : `${MONTHS[s.m].slice(0, 3)} ${s.d} – ${MONTHS[e.m].slice(0, 3)} ${e.d}`;
};

export const formatCohortRange = (c) => {
  const s = parts(c.start_date);
  const e = parts(c.end_date);
  let r;
  if (s.y !== e.y) r = `${MONTHS[s.m]} ${s.d}, ${s.y} – ${MONTHS[e.m]} ${e.d}, ${e.y}`;
  else if (s.m !== e.m) r = `${MONTHS[s.m]} ${s.d} – ${MONTHS[e.m]} ${e.d}, ${s.y}`;
  else r = `${MONTHS[s.m]} ${s.d}–${e.d}, ${s.y}`;
  return c.timezone ? `${r} (${c.timezone})` : r;
};

export const upcomingCohorts = (course, format) => {
  const today = todayStr();
  return (course?.cohorts || [])
    .filter((c) => (!format || c.format === format) && c.start_date >= today)
    .sort((a, b) => a.start_date.localeCompare(b.start_date));
};
